import ceshopLogo from "@/assets/ceshop-logo.svg";

/**
 * Compact "Featured Speaker" credit for The CE Shop.
 *
 * The webinar has already aired, so this is a small authority strip near the
 * bottom of the homepage: their logo plus the session title. No date, no
 * registration CTA, no event promotion.
 */
const CeShopFeature = () => {
  return (
    <section className="py-12 md:py-16 bg-[#F9F7F2] border-t border-[#C5A059]/20">
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-[0.7rem] md:text-[0.75rem] uppercase tracking-[0.25em] text-[hsl(var(--accent-strong))] font-semibold mb-5">
            As Seen On
          </p>
          <img
            src={ceshopLogo}
            alt="The CE Shop"
            className="h-9 md:h-11 w-auto mx-auto mb-5"
            loading="lazy"
          />
          <p className="text-base md:text-lg font-semibold text-[#0A192F] leading-snug">
            AI in Real Estate: Getting Started Without the Overwhelm
          </p>
          <p className="text-sm md:text-base text-[#0A192F]/70 mt-2">
            Invited as a broker-owner who builds and runs her own AI systems.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CeShopFeature;
